import { useCallback, useState } from 'react';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import { TransformForm } from '../_partials/TransformForm';
import { TransformSchemaValues } from '@/zod/schemas/transforms/TransformSchema';
import { setTransformFromValues } from '@/lib/transform/transformHelpers';
import { useCreateTransform } from '@/hooks/core/useCreateTransform';
import { useGetTransformsInfinite } from '@/hooks/core/useGetTransformsInfinite';

export default function AddTransform() {
  const navigate = useNavigate();
  const { mutateAsync: create, isPending: isSubmitting } = useCreateTransform();
  const { optimisticUpdate } = useGetTransformsInfinite();
  const [responseError, setResponseError] = useState<
    AxiosError<{ message: string }> | undefined
  >(undefined);

  const onSubmit = useCallback(
    async (values: TransformSchemaValues) => {
      const transform = setTransformFromValues(values, undefined);
      await create(transform, {
        toasts: {
          success: 'Transform created successfully',
          error: 'Failed to create transform',
        },
        onSuccess: async () => {
          optimisticUpdate(transform);
          navigate('/configure/transforms');
        },
        onError: async ({ error }) => {
          setResponseError(error as AxiosError<{ message: string }>);
        },
      });
    },
    [create, navigate, optimisticUpdate],
  );

  return (
    <TransformForm
      transform={{
        spec: {
          schedule: {
            atLeastEvery: '10m',
          },
        },
      }}
      responseError={responseError}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
      isInEditMode={false}
    />
  );
}
